var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "48px",
    viewBox: "0 0 60 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FF897B52-BF87-4B4E-99B6-FDD9CD5E8259") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "1.11023228e-15 0 60 0 60 48 1.11023228e-15 48"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage",
    transform: "translate(-1054.000000, -5920.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1054.000000, 5920.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11505929,9.79257642 C7.19005992,9.04937857 6.90755756,8.31625798 6.35755298,7.81743366 L0.757506313,1.01528384 L0.757506313,0 L18.1526513,0 L31.5977633,29.7153174 L43.4178618,0 L60.0005,0 L60.0005,1.01528384 L55.2104601,5.64326503 C54.7979566,5.96069869 54.5929549,6.48219684 54.6779556,6.99865637 L54.6779556,41.0043668 C54.5929549,41.518307 54.7979566,42.0372859 55.2104601,42.3572388 L59.8879991,46.98522 L59.8879991,48.0005039 L36.357803,48.0005039 L36.357803,46.98522 L41.2053434,42.2413504 C41.6803473,41.7651999 41.6803473,41.6241182 41.6803473,40.8909976 L41.6803473,13.4052738 L28.2077351,47.889654 L26.3877199,47.889654 L10.7000892,13.4052738 L10.7000892,36.5174672 C10.5700881,37.4874034 10.8900908,38.4648975 11.5675964,39.1677864 L17.8701489,46.8718509 L17.8701489,47.889654 L1.11023228e-15,47.889654 L1.11023228e-15,46.8718509 L6.30255252,39.1677864 C6.97755815,38.4623782 7.27756065,37.4798455 7.11505929,36.5174672 L7.11505929,9.79257642 Z",
    id: "Fill-1",
    fill: "#330366",
    mask: "url(#mask-2)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.c52423d4c8e7d3e696d445f09ecd9f12.svg";
export { ForwardRef as ReactComponent };